import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

function SlimLoadingBar() {
  const location = useLocation();
  const [phase, setPhase] = useState('idle');
  const skipFirst = useRef(true);

  useEffect(() => {
    if (skipFirst.current) {
      skipFirst.current = false;
      return undefined;
    }

    let rafId = 0;
    let t1;
    let t2;

    setPhase('start');
    rafId = requestAnimationFrame(() => {
      setPhase('loading');
    });

    t1 = setTimeout(() => setPhase('complete'), 300);
    t2 = setTimeout(() => setPhase('idle'), 520);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [location.pathname, location.search, location.hash, location.key]);

  if (phase === 'idle') {
    return null;
  }

  return (
    <div
      className={`slim-loading-bar slim-loading-bar--${phase}`}
      role="progressbar"
      aria-hidden="true"
    >
      <div className="slim-loading-bar__track">
        <div className="slim-loading-bar__fill" />
      </div>
    </div>
  );
}

export default SlimLoadingBar;
